import Img from "react-cool-img";
import { motion } from "framer-motion";
import React from "react";
import { CuratedTeacher, Faculty } from "models";
import { Spinner, Col } from "react-bootstrap";
import { variants } from "components/AnimatedRoutes";
import { PicWallItemPin } from "components/MapView";
import "./PictureWall.scss";

interface PictureWallProps<I extends CuratedTeacher | Faculty> {
  data?: I[];
  background?: boolean;
  isLoading: boolean;
}

export function PictureWall<I extends CuratedTeacher | Faculty>({
  data,
  background,
  isLoading,
}: PictureWallProps<I>): JSX.Element {
  return (
    <motion.div
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        x: { bounce: 0, duration: 0.5, type: "spring" },
      }}
    >
      <div className={`map-container${background ? " background" : " foreground-map"}`}>
        <div className="background-image-container">
          <div className="grid-container">
            <div className="elementary">
              <div className="logo">Elementary</div>
              {isLoading ? (
                <Spinner animation="border" />
              ) : (
                data &&
                data
                  .filter(
                    teacher => teacher.major === "elementary" && teacher.type === "student-teacher",
                  )
                  .map(teacher => <PictureWallTeacherCard key={teacher.id} teacher={teacher} />)
              )}
            </div>

            <div className="secondary">
              <div className="logo">Secondary</div>
              {isLoading ? (
                <Spinner animation="border" />
              ) : (
                data &&
                data
                  .filter(
                    teacher => teacher.major === "secondary" && teacher.type === "student-teacher",
                  ) // THIS SHOULD BE SECONDARY
                  .map(teacher => <PictureWallTeacherCard key={teacher.id} teacher={teacher} />)
              )}
            </div>
            <div className="sped">
              <div className="logo">Special Ed</div>
              {isLoading ? (
                <Spinner animation="border" />
              ) : (
                data &&
                data
                  .filter(
                    teacher =>
                      teacher.major === "special-education" && teacher.type === "student-teacher",
                  )
                  .map(teacher => <PictureWallTeacherCard key={teacher.id} teacher={teacher} />)
              )}
              {}
            </div>
            <div className="faculty">
              <div className="logo">Faculty</div>
              {isLoading ? (
                <Spinner animation="border" />
              ) : (
                data &&
                data
                  .filter(teacher => teacher.type === "faculty")
                  .map(teacher => <PictureWallTeacherCard key={teacher.id} teacher={teacher} />)
              )}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

interface PictureWallTeacherCardProps {
  teacher: CuratedTeacher | Faculty;
}

function PictureWallTeacherCard({ teacher }: PictureWallTeacherCardProps): JSX.Element {
  const detailType = "picture-wall-student-teacher";

  return (
    <>
      <Col>
        <div className="picture-wall-box">
          <div className="img-square-container img-background">
            <PicWallItemPin item={teacher} key={teacher.id} detailType={detailType} />
            <Img src={teacher.photoUrl} width="100%" loading="lazy" />
          </div>
          <p className="nameCards">
            {teacher.firstName} {teacher.lastName}
          </p>
        </div>
      </Col>
    </>
  );
}
